import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const RNFI_DischargeSummary = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='RNFI_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>

            <table>
                    <tr>
                        <td className='w-750'><h2>Common Items </h2>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Participant Accompanied By</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticiapantAccompanied_1' name='cbParticiapantAccompanied_1' className='add-only' value='Self' /> Self
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticiapantAccompanied_2' name='cbParticiapantAccompanied_2' className='add-only' value='Family' /> Family
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticiapantAccompanied_3' name='cbParticiapantAccompanied_3' className='add-only' value='SignificantOther' />Significant Other
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbParticiapantAccompanied_4' name='cbParticiapantAccompanied_4' className='add-only' value='LegalGuardian' /> Legal
                            Guardian
                        </td></tr>
                    <tr><td className='w-750'>
                        <input type='checkbox' id='cbParticiapantAccompanied_5' name='cbParticiapantAccompanied_5' className='add-only' value='Other' /> Other</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Legal Guardian/Custodian Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtLegalGuardianName' name='txtLegalGuardianName' className='add-only' />

                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Present Problem(s)</span>
                            <span className='small'>(When began, duration/intensity of symptons, stressors/precipitants,
                                list participants conception of presenting problems and what the participant perceives to be the important issues to beaddressed.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtHistoryPresentProblem' name='txtHistoryPresentProblem' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Prior MH/SA/DD History</span>
                            <span className='small'>(Include residential treatment, inpatient, outpatient, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPriorHistory' name='txtPriorHistory' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>History of Traumatic Events</span>
                            <span className='small'>(Consider neglect or abuse, violence, significant losses, accidents, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtHistoryTraumaticEvents' name='txtHistoryTraumaticEvents' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Living Situation</span>
                            <span className='small'>(Where, with whom, relationship, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Education History</span>
                            <span className='small'>(Consider special education, behavior programs, grade level - current or achieved, school, attitude, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtEducationHistory' name='txtEducationHistory' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Vocational History</span>
                            <span className='small'>(Include current Employment, military, vocational difficulties, handicaps, if unemployed - work plan, etc.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtVocationalHistory' name='txtVocationalHistory' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Family History</span>
                            <span className='small'>(Include any MH/DD/SA history of biological family, immediate family/significant others, diagnosis, treatment, etc.)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtFamilyHistory' name='txtFamilyHistory' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Social History</span>
                            <span className='small'>(Include friendships, significant relationships, religious and cultural activities, hobbies, recreation)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtSocialHistory' name='txtSocialHistory' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Transcultural Factors</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtTransculturalFactors' name='txtTransculturalFactors' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>Consumer Information</h2></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of Discharge</span></td>
                        <td className='w-375'><span className='eleHeader'>Therapist's Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtAsisCode' name='txtDateOfDischarge' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtTherapistName' name='txtTherapistName' className='add-only' /> </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><h2>I. Initial Diagnosis</h2>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>AXIS I Code #</span></td>
                        <td className='w-375'><span className='eleHeader'>AXIS II Code #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtInitialDiagnosis_1' name='txtInitialDiagnosis_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtInitialDiagnosis_2' name='txtInitialDiagnosis_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>AXIS III Code #</span></td>
                        <td className='w-375'><span className='eleHeader'>AXIS IV Code #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtInitialDiagnosis_3' name='txtInitialDiagnosis_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtInitialDiagnosis_4' name='txtInitialDiagnosis_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>AXIS V GAF</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtInitialDiagnosis_5' name='txtInitialDiagnosis_5' className='add-only' /> </td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-750'><h2>II. Discharge Diagnosis</h2></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>AXIS I Code #</span></td>
                        <td className='w-375'><span className='eleHeader'>AXIS II Code #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txDischargeDiagnosis_1' name='txDischargeDiagnosis_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDischargeDiagnosis_2' name='txtDischargeDiagnosis_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>AXIS III Code #</span></td>
                        <td className='w-375'><span className='eleHeader'>AXIS IV Code #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDischargeDiagnosis_3' name='txtDischargeDiagnosis_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDischargeDiagnosis_4' name='txtDischargeDiagnosis_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>AXIS V GAF</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeDiagnosis_5' name='txtDischargeDiagnosis_5' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>III. Services and Termination Status</h2>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Opening Date</span></td>
                        <td className='w-250'><span className='eleHeader'>Termination Date</span></td>
                        <td className='w-250'><span className='eleHeader'>Total Number of Sessions</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtOpeningDate' name='txtOpeningDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtTerminationDate' name='txtTerminationDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTotalNumberOfSessions' name='txtTotalNumberOfSessions' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Discharge Criteria</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeCriteria' name='txtDischargeCriteria' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Consumer was to meet all the goals of his treatment plan which included</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtConsumerWasToMeetAllTheGoals' name='txtConsumerWasToMeetAllTheGoals' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Living Situation at the Time of Discharge</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtLivingSituationAtTheTimeOfDischarge' name='txtLivingSituationAtTheTimeOfDischarge' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Which of the following services were used with the client during the program?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_1' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_1' className='add-only' value='Csi' /> CSI
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_2' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_2' className='add-only' value='Family' /> Family
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_3' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_3' className='add-only' value='TransitionPlanning' />Transition Planning
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_4' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_4' className='add-only' value='Group' /> Group
                        </td>
                    </tr>


                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_5' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_5' className='add-only' value='Individual' /> Individual
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_6' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_6' className='add-only' value='Psych' />Psych
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_7' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_7' className='add-only' value='Testing' />Testing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_8' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_8' className='add-only' value='Psychiatric' /> Psychiatric
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClient_9' name='cbWhichOfTheFollowingServicesWereUsedWithTheClient_9' className='add-only' value='FamilyTeamConferencing' />Family Team Conferencing
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWhichOfTheFollowingServicesWereUsedWithTheClientOther' name='cbWhichOfTheFollowingServicesWereUsedWithTheClientOther' className='add-only' value='Other' />Other : &nbsp;
                            <input type='text' id='txtWhichOfTheFollowingServicesWereUsedWithTheClientOther' name='txtWhichOfTheFollowingServicesWereUsedWithTheClientOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                
                <p className='w-750'><h2>IV. Overall Status at Termination</h2></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Overall status at termination</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtOverallStatusTermination' name='txtOverallStatusTermination' className='add-only' /> </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><h2>V. Reason(s) for Termination</h2></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_1' name='cbReasonForTermination_1' className='add-only' value='DischargedAsPlanned' /> Discharged as planned
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_2' name='cbReasonForTermination_2' className='add-only' value='ReferredForOtherServices' /> Referred for other services
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_3' name='cbReasonForTermination_3' className='add-only' value='InsufficientProgressInTherapy' />Insufficient progress in therapy
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_4' name='cbReasonForTermination_4' className='add-only' value='NoLongerMakingAppointments' /> No longer making appointments
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_5' name='cbReasonForTermination_5' className='add-only' value='HaveMissecExcessiveAppointments' />Have missed excessive appointments
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_6' name='cbReasonForTermination_6' className='add-only' value='TherapistIsLeavingTheClinicOrArea' />Therapist is leaving the clinic or area
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReasonForTermination_7' name='cbReasonForTermination_7' className='add-only' value='v TeminatedAgainstTherapistAdvice' /> Teminated against therapist's advice
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReasonForTermination_8' name='cbReasonForTermination_8' className='add-only' value='Other' />Other : &nbsp;
                            <input type='text' id='txtReasonForTermination_8' name='txtReasonForTermination_8' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>VI. Presenting Problem and Assessment</h2></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Presenting problem and assessment</span>
                            <span className='small'>Subjective evaluation: Summarize specific symptomology, onset, duration and frequency of Sx's. Include consumer's
                                assessment of presenting problems and reason(s) for seeking services. Also include factors such as family or environmental factors affecting functioning.
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPresentingProblemAndAssessment' name='txtPresentingProblemAndAssessment' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Consumer's Strengths, Needs, Abilities and Preferences (SNAPS)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtConsumerStrengthsNeedsAbilitiesAndPreferences' name='txtConsumerStrengthsNeedsAbilitiesAndPreferences' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>VII. Clinical Course</h2></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Clinical Course</span>
                            <span className='small'>Impact of services upon each problem identified in the TREATMENT PLAN. What the client and therapist did to
                                become healthy and was there any improvement in the consumer's condition in regards
                                to specific problem areas.</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtClinicalCourse' name='txtClinicalCourse' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>VIII. Medical/Psychiatric Status</h2></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Medical/Psychiatric Status</span>
                            <span className='small'>Was the consumer seen by the psychiatrist for either a psychiatric evaluation or for medications? Discharge meds, dosages and instructions.
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtMedicalPsychiatric' name='txtMedicalPsychiatric' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Discharge Medication and Dosage</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeMedicationAndDosage' name='txtDischargeMedicationAndDosage' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>IX. Post-Termination Plan</h2>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Post-Termination Plan</span><span className='small'>Include referrals, appointments, dispositions, and consumer's reaction.</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPostTerminationPlan' name='txtPostTerminationPlan' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Goals not met from the treatment plan</span><span className='small'>Provide details of goals not met.</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtGoalsNotMetFromTheTreatmentPlan' name='txtGoalsNotMetFromTheTreatmentPlan' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>X. Consumer's Statement Regarding Satisfaction of Treatment Rendered</h2>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Consumer's statement regarding satisfaction of treatment rendered</span>
                            <span className='small'>What did the consumer say about their satisfaction with the course of treatment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtConsumerStatementRegardingSatisfactionOfTreatmentRendered' name='txtConsumerStatementRegardingSatisfactionOfTreatmentRendered' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Therapist's recommendations #1</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtTherapistRecommendations_1' name='txtTherapistRecommendations_1' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Therapist's recommendations #2</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtTherapistRecommendations_2' name='txtTherapistRecommendations_2' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Therapist's recommendations #3</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtTherapistRecommendations_3' name='txtTherapistRecommendations_3' className='add-only' /> </td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-750'><h2>XI. Outcome Measures (CAFAS)</h2>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Pre CAFAS Score (at admission)</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>School</span></td>
                        <td className='w-375'><span className='eleHeader'>Home</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPreScore_1' name='txtPreScore_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPreScore_2' name='txtPreScore_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Community</span></td>
                        <td className='w-375'><span className='eleHeader'>Behavior Towards Others</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPreScore_3' name='txtPreScore_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPreScore_4' name='txtPreScore_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mood/Emotions</span></td>
                        <td className='w-375'><span className='eleHeader'>Self-Harm</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPreScore_5' name='txtPreScore_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPreScore_6' name='txtPreScore_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Substance Use</span></td>
                        <td className='w-375'><span className='eleHeader'>Thinking</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPreScore_7' name='txtPreScore_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPreScore_8' name='txtPreScore_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TOTAL</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPreScore_9' name='txtPreScore_9' className='add-only' /> </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><b>Post CAFAS Score (at discharge)</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>School</span></td>
                        <td className='w-375'><span className='eleHeader'>Home</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPostScore_1' name='txtPostScore_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPostScore_2' name='txtPostScore_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Community</span></td>
                        <td className='w-375'><span className='eleHeader'>Behavior Towards Others</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPostScore_3' name='txtPostScore_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPostScore_4' name='txtPostScore_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Mood/Emotions</span></td>
                        <td className='w-375'><span className='eleHeader'>Self-Harm</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPostScore_5' name='txtPostScore_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPostScore_6' name='txtPostScore_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Substance Use</span></td>
                        <td className='w-375'><span className='eleHeader'>Thinking</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPostScore_7' name='txtPostScore_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPostScore_8' name='txtPostScore_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TOTAL</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPostScore_9' name='txtPostScore_9' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>XI. Summary of CAFAS scores pre and post</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtSummaryOfCafasScoresPreAndPost' name='txtSummaryOfCafasScoresPreAndPost' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><h2>XII. Aftercare Plan (Six month follow-up)</h2></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>XII. Aftercare Plan at six months post treatment/follow-up</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAfterCarePlanAtSixMonthsPostTreatment' name='txtAfterCarePlanAtSixMonthsPostTreatment' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Location of Discharge</span></td>
                        <td className='w-375'><span className='eleHeader'>Anticipated Step Down Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtLocationOfDischarge' name='txtLocationOfDischarge' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAnticipatedStepDownService' name='txtAnticipatedStepDownService' className='add-only' /> </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
 